import {useEffect, useState} from "react";
import "./PageWrapper.scss";
import NavigationMenu from "./Navigation/NavigationMenu";

const PageWrapper = ({children, topPadding}) => {
    const [offHeight, setOffHeight] = useState(0);

    useEffect(() => {
        const tn = document.getElementById("custom-top-navigation");

        const listens = () => [
            document.getElementById("wpadminbar"),
            document.getElementById("site-navigation"),
            tn,
        ].filter(Boolean);

        function recalc() {
            setOffHeight(listens().reduce((out, curr) => out + curr.scrollHeight, 0));
        }

        listens().forEach(l => l.addEventListener("resize", recalc));

        recalc();

        return () => {
            listens().forEach(l => l.removeEventListener("resize", recalc))
        }
    }, []);

    return <>
        <NavigationMenu />
        <div className={`${topPadding ? "top-padding " : ""}page-clamper`} style={{maxHeight: `calc(100vh - ${offHeight + 1}px)`, height: `calc(100vh - ${offHeight + 1}px)`}}>
        {children}
    </div>
    </>
}

export default PageWrapper;